import React from 'react';
import { SatCoreRegister, StudentAssignmentCard } from 'sat-core';

const StudentAssignmentCardOverride = (props = {}) => {
  const hideCourseTitle = typeof props.hideCourseTitle === 'boolean' ? props.hideCourseTitle : false;
  return (
    <StudentAssignmentCard
      {...props}
      dashboard={false}
      hideCourseTitle={hideCourseTitle} />
  );
};

SatCoreRegister('StudentAssignmentCard', StudentAssignmentCardOverride);
